import { pdfjs } from 'react-pdf';

// pdfjs 4 defaults workerSrc to "./pdf.worker.mjs", which browsers cannot resolve
// as a bare module specifier (Sentry CUSTOMER-PORTAL-2G1). Use the bundled worker.
pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.mjs', import.meta.url).toString();
